// @ts-nocheck
import { PROFILE_ERROR, PROFILE_LOADING, PROFILE_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const profile = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: PROFILE_LOADING,
                data: true
            })
            Authservices.profile(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: PROFILE_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: PROFILE_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}